/**
 * Vehicle Model for FlowRide Frontend
 * Display metadata for a realtime trip. Trajectory data lives in {@link RealtimeCache}
 * (CompactTimeline) and is read via {@link InterpolationEngine} — not duplicated here.
 */

import { type Color } from "./AtlasConfig";
import { type VehicleType } from "./VehicleType";

export class Vehicle {

    /** Unique vehicle identifier (trip id). */
    id!: string;

    /** Type of vehicle (bus, tram, etc.). */
    type!: VehicleType;

    /** Vehicle label/name (typically route short name). */
    label!: string;

    /** Vehicle color for display. */
    color!: Color;

    /** Last time schedule/timeline metadata was updated (for cleanup). */
    public lastUpdateTime!: number;

    /**
     * Creates a vehicle metadata instance.
     *
     * @param id Trip identifier.
     * @param type Vehicle type for icon selection.
     * @param label Display label.
     */
    constructor( id: string, type: VehicleType, label: string ) {
        this.id = id;
        this.type = type;
        this.label = label;
        this.color = {
            "r": 255,
            "g": 0,
            "b": 0,
        };
        this.lastUpdateTime = Date.now();
    }

}
